// import Swiper JS
import Swiper, { Navigation, Pagination, Scrollbar } from "swiper";

export class OfferPage {
  constructor() {
    // OFFER PAGE MAINTENANCE CAROUSEL SWIPER
    const maintenanceSwiper = new Swiper("#swiper-maintenance", {
      // Optional parameters
      direction: "horizontal",
      allowTouchMove: true,
      modules: [Navigation, Scrollbar],
      resizeObserver: true,
      breakpoints: {
        0: {
          enabled: true,
          slidesPerView: "auto",
          // centeredSlides: true,
          centeredSlides: false,
          spaceBetween: 16,
          navigation: {
            nextEl: ".maintenance-button-next",
            prevEl: ".maintenance-button-prev",
          },
          scrollbar: {
            enabled: false,
          },
        },
        768: {
          enabled: true,
          slidesPerView: 3.1,
          // slidesPerGroup: 3,
          loopFillGroupWithBlank: true,
          centeredSlides: false,
          spaceBetween: 20,
          navigation: {
            nextEl: ".maintenance-button-next",
            prevEl: ".maintenance-button-prev",
          },
          scrollbar: {
            enabled: true,
            el: ".maintenance-scrollbar",
            hide: false,
            draggable: true,
            dragSize: "auto",
          },
        },
        992: {
          enabled: true,
          slidesPerView: 3.3,
          // slidesPerGroup: 3,
          loopFillGroupWithBlank: true,
          centeredSlides: false,
          spaceBetween: 20,
          allowTouchMove: false,
          simulateTouch: false,
          navigation: {
            nextEl: ".maintenance-button-next",
            prevEl: ".maintenance-button-prev",
          },
          scrollbar: {
            enabled: true,
            el: ".maintenance-scrollbar",
            hide: false,
            draggable: true,
            dragSize: "auto",
          },
        },
      },
    });

    const repairSwiper = new Swiper("#swiper-repair", {
      // Optional parameters
      direction: "horizontal",
      allowTouchMove: true,
      modules: [Navigation, Scrollbar],
      resizeObserver: true,
      breakpoints: {
        0: {
          enabled: true,
          slidesPerView: "auto",
          // centeredSlides: true,
          centeredSlides: false,
          spaceBetween: 16,
          navigation: {
            nextEl: ".repair-button-next",
            prevEl: ".repair-button-prev",
          },
          scrollbar: {
            enabled: false,
          },
        },
        768: {
          enabled: true,
          slidesPerView: 3.1,
          slidesPerGroup: 3,
          loopFillGroupWithBlank: true,
          centeredSlides: false,
          spaceBetween: 20,
          navigation: {
            nextEl: ".repair-button-next",
            prevEl: ".repair-button-prev",
          },
          scrollbar: {
            enabled: true,
            el: ".repair-scrollbar",
            hide: false,
            draggable: true,
            dragSize: "auto",
          },
        },
        992: {
          enabled: true,
          slidesPerView: 3.3,
          slidesPerGroup: 3,
          loopFillGroupWithBlank: true,
          centeredSlides: false,
          spaceBetween: 20,
          allowTouchMove: false,
          simulateTouch: false,
          navigation: {
            nextEl: ".repair-button-next",
            prevEl: ".repair-button-prev",
          },
          scrollbar: {
            enabled: true,
            el: ".repair-scrollbar",
            hide: false,
            draggable: true,
            dragSize: "auto",
          },
        },
      },
    });

    const installationSwiper = new Swiper("#swiper-installation", {
      // Optional parameters
      direction: "horizontal",
      allowTouchMove: true,
      modules: [Navigation, Scrollbar],
      resizeObserver: true,
      breakpoints: {
        0: {
          enabled: true,
          slidesPerView: "auto",
          // centeredSlides: true,
          centeredSlides: false,
          spaceBetween: 16,
          navigation: {
            nextEl: ".installation-button-next",
            prevEl: ".installation-button-prev",
          },
          scrollbar: {
            enabled: false,
          },
        },
        768: {
          enabled: true,
          slidesPerView: 3.1,
          slidesPerGroup: 3,
          loopFillGroupWithBlank: true,
          centeredSlides: false,
          spaceBetween: 20,
          navigation: {
            nextEl: ".installation-button-next",
            prevEl: ".installation-button-prev",
          },
          scrollbar: {
            enabled: true,
            el: ".installation-scrollbar",
            hide: false,
            draggable: true,
            dragSize: "auto",
          },
        },
        992: {
          enabled: true,
          slidesPerView: 3.3,
          slidesPerGroup: 3,
          loopFillGroupWithBlank: true,
          centeredSlides: false,
          spaceBetween: 20,
          allowTouchMove: false,
          simulateTouch: false,
          navigation: {
            nextEl: ".installation-button-next",
            prevEl: ".installation-button-prev",
          },
          scrollbar: {
            enabled: true,
            el: ".installation-scrollbar",
            hide: false,
            draggable: true,
            dragSize: "auto",
          },
        },
      },
    });
    //gestione how services

    const tabButtons =
      document.querySelectorAll<HTMLElement>(".how-services-btn");
    const slides = document.querySelectorAll(".swiper-slide");
    const carousels = document.querySelectorAll<HTMLElement>(
      ".how-services-carousel"
    );
    if (tabButtons && carousels && carousels.length > 0) {
      slides.forEach((slide) => {
        slide.classList.add("slide-inactive");
      });
      //inizializzo tutti gli swipers
      carousels.forEach((c: HTMLElement) => {
        const tabIndex = c.dataset.tabindex;
        //visualizzo la prima tab
        if (tabIndex == "0") {
          c.classList.remove("d-none");
        }
        this.loadHowServicesSlideSwiper(tabIndex);
      });

      tabButtons.forEach((btn) => {
        if (btn.dataset.tabindex == "0") {
          btn.classList.add("selected");
        }
      });
      this.loadHowServicesTabSwiper();

      //inizializzo il click sulle tab
      tabButtons.forEach((btn) => {
        btn.addEventListener("click", (event: Event) => {
          const tabIndex = (event.target as HTMLElement).dataset.tabindex;

          slides.forEach((slide) => {
            slide.classList.remove("slide-active");
          });

          console.log(
            btn.parentElement.parentElement.classList.toggle("slide-active")
          );

          this.toggleHowServiceTabButton(tabButtons, tabIndex);

          carousels &&
            carousels.forEach((c: HTMLElement) => {
              const index = c.dataset.tabindex;
              if (index == tabIndex) {
                c.classList.remove("d-none");
              } else {
                c.classList.add("d-none");
              }
            });
        });
      });
    }
  }
  toggleHowServiceTabButton(
    buttons: NodeListOf<HTMLElement>,
    tabIndex: string
  ) {
    buttons.forEach((btn) => {
      let currentTabIndex = btn.dataset.tabindex;
      if (tabIndex == currentTabIndex) {
        btn.classList.add("selected");
      } else {
        btn.classList.remove("selected");
      }
    });
  }
  loadHowServicesSlideSwiper(tabindex: string) {
    return new Swiper("#swiper-how-services-" + tabindex, {
      // Optional parameters
      direction: "horizontal",
      modules: [Navigation],
      resizeObserver: true,
      speed: 0,
      enabled: true,
      slidesPerView: 1,
      centeredSlides: false,
      spaceBetween: 10,
      navigation: {
        nextEl: "#how-services-button-next-" + tabindex,
        prevEl: "#how-services-button-prev-" + tabindex,
      },
    });
  }
  loadHowServicesTabSwiper() {
    return new Swiper("#tabSwiper", {
      // Optional parameters
      direction: "horizontal",
      modules: [Scrollbar, Pagination],
      enabled: true,
      slidesPerView: 2.5,
      pagination: {
        el: ".tabSwiperPagination",
        type: "progressbar",
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
      },
    });
  }
}
